<template>
    <div class="rows-input-container">
        <slot></slot>
        <!-- <input type="number" class="rows-input" :value="internalValue" @input="handleInput" :min="min" :max="max" @change="handleChange" /> -->
        <el-input-number v-model="internalValue" @change="handleChange" :min="min" :max="max" label=""></el-input-number>
    </div>
</template>

<script>
export default {
    name: 'RowsInput',
    props: {
        value: {
            type: Number,
            default: 3,
        },
        max: {
            type: Number,
            default: 10,
        },
        min: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        internalValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    methods: {
        handleInput(event) {
            if (event.target.value === '') {
                this.internalValue = this.min;
                return;
            }
            let newValue = Number(event.target.value);
            if (newValue > this.max) {
                newValue = this.max;
            } else if (newValue < this.min) {
                newValue = this.min;
            }
            this.internalValue = newValue;
        },
        handleChange(value) {
            this.$emit('onChange', value);
        }
    },
}
</script>

<style scoped>
.rows-input-container {
    display: inline-block;
}

.rows-input-container .el-input-number {
    margin-left: 8px;
}
</style>
